/* STADTHOLZ Warenkorbseite (sections/sz-main-cart.liquid)
   Mengen, Entfernen und Hinzufuegen per Cart-AJAX mit Section-Rendering
   (sections = diese Section + cart-icon-bubble). Ohne JS bleibt das Formular voll nutzbar.
   Empfehlungen: Shopify Product Recommendations API (complementary, Fallback related). */

(function () {
  'use strict';

  if (window.__szCartBound) return;
  window.__szCartBound = true;

  var ROOT_SEL = '[data-sz-cart-root]';
  var FEHLER = 'Das hat gerade nicht geklappt. Bitte versuch es noch einmal oder lade die Seite neu.';
  var WELT = {
    holzbrillen: 'Holzbrille',
    holzfliegen: 'Holzfliege',
    sonnenbrillen: 'Sonnenbrille',
    holzuhren: 'Holzuhr',
    wechselstoffe: 'Wechselstoff',
    accessoires: 'Accessoires',
  };

  var state = {
    timers: {},
    error: '',
    queue: Promise.resolve(),
    observer: null,
    recsCache: {},
  };

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getRoot() {
    return document.querySelector(ROOT_SEL);
  }

  function sectionId() {
    var r = getRoot();
    return r ? r.getAttribute('data-section-id') : null;
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function announce(msg) {
    var live = document.querySelector('[data-sz-cart-live]');
    if (!live || !msg) return;
    live.textContent = '';
    setTimeout(function () {
      live.textContent = msg;
    }, 60);
  }

  function setBusy(on) {
    var r = getRoot();
    if (!r) return;
    r.classList.toggle('is-busy', on);
    r.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function enqueue(task) {
    state.queue = state.queue.then(task, task);
    return state.queue;
  }

  /* ---------- Rendering ---------- */

  function updateBubble(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cart-icon-bubble') || tmp.querySelector('.shopify-section') || tmp;
    document.querySelectorAll('#cart-icon-bubble, .sz-header__cart--menu').forEach(function (target) {
      target.innerHTML = fresh.innerHTML;
    });
  }

  function applySections(sections, focusKey) {
    var id = sectionId();
    if (id && sections && sections[id]) {
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.querySelector(ROOT_SEL);
      var current = getRoot();
      if (fresh && current) current.replaceWith(fresh);
    }
    if (sections && sections['cart-icon-bubble']) updateBubble(sections['cart-icon-bubble']);
    afterRender(focusKey);
    document.dispatchEvent(new CustomEvent('sz:cart:changed'));
  }

  function restoreFocus(focusKey) {
    if (!focusKey) return;
    var target = null;
    if (focusKey !== '__title') {
      document.querySelectorAll('[data-sz-focus]').forEach(function (el) {
        if (el.getAttribute('data-sz-focus') === focusKey) target = el;
      });
      if (target && target.disabled) {
        var line = target.closest('[data-sz-line]');
        target = line ? line.querySelector('[data-sz-qty-input]') : null;
      }
    }
    if (!target) target = document.querySelector('[data-sz-cart-title]');
    if (target) target.focus({ preventScroll: true });
  }

  function afterRender(focusKey) {
    var errBox = document.querySelector('[data-sz-cart-error]');
    if (errBox) {
      if (state.error) {
        errBox.textContent = state.error;
        errBox.hidden = false;
      } else {
        errBox.hidden = true;
        errBox.textContent = '';
      }
    }
    restoreFocus(focusKey);
    initSticky();
    initRecs();
  }

  function refresh(focusKey) {
    var id = sectionId();
    if (!id) return Promise.resolve();
    var url = window.location.pathname + '?sections=' + encodeURIComponent(id) + ',cart-icon-bubble';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        applySections(sections, focusKey);
      })
      .catch(function () {
        afterRender(focusKey);
      });
  }

  function post(path, body, focusKey, okMessage) {
    var id = sectionId();
    if (!id) return Promise.resolve();
    body.sections = [id, 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    state.error = '';
    setBusy(true);

    return fetch(routeRoot() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data || {} };
        });
      })
      .then(function (r) {
        if (!r.ok || !r.data.sections) {
          state.error = r.data.description || r.data.message || FEHLER;
          return refresh(focusKey);
        }
        applySections(r.data.sections, focusKey);
        announce(okMessage);
      })
      .catch(function () {
        state.error = FEHLER;
        return refresh(focusKey);
      })
      .then(function () {
        setBusy(false);
      });
  }

  /* ---------- Mengen ---------- */

  function bounds(input) {
    var min = parseInt(input.getAttribute('data-min'), 10);
    if (isNaN(min) || min < 1) min = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    return { min: min, max: isNaN(max) ? null : max };
  }

  function syncButtons(line, input, qty) {
    var b = bounds(input);
    line.querySelectorAll('[data-sz-qty-step]').forEach(function (btn) {
      var dir = parseInt(btn.getAttribute('data-sz-qty-step'), 10);
      btn.disabled = dir < 0 ? qty <= b.min : b.max !== null && qty >= b.max;
    });
  }

  function schedule(line, input, focusKey, delay) {
    var key = line.getAttribute('data-key');
    clearTimeout(state.timers[key]);
    state.timers[key] = setTimeout(function () {
      delete state.timers[key];
      var qty = parseInt(input.value, 10);
      var before = line.getAttribute('data-quantity');
      if (isNaN(qty) || qty < 0) {
        input.value = before;
        syncButtons(line, input, parseInt(before, 10));
        return;
      }
      var b = bounds(input);
      if (qty > 0 && b.max !== null && qty > b.max) qty = b.max;
      if (String(qty) === before) return;
      var title = line.getAttribute('data-title') || 'Artikel';
      var msg = qty === 0 ? title + ' wurde entfernt.' : 'Menge von ' + title + ' ist jetzt ' + qty + '.';
      enqueue(function () {
        return post('cart/change.js', { id: key, quantity: qty }, qty === 0 ? '__title' : focusKey, msg);
      });
    }, typeof delay === 'number' ? delay : 400);
  }

  function onStep(btn) {
    var line = btn.closest('[data-sz-line]');
    var input = line && line.querySelector('[data-sz-qty-input]');
    if (!input) return;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var dir = parseInt(btn.getAttribute('data-sz-qty-step'), 10) || 0;
    var cur = parseInt(input.value, 10);
    if (isNaN(cur)) cur = parseInt(line.getAttribute('data-quantity'), 10) || 1;
    var b = bounds(input);
    var next = cur + dir * step;
    if (next < b.min) next = b.min;
    if (b.max !== null && next > b.max) next = b.max;
    input.value = next;
    syncButtons(line, input, next);
    schedule(line, input, btn.getAttribute('data-sz-focus'));
  }

  function onRemove(link) {
    var line = link.closest('[data-sz-line]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var group = line.getAttribute('data-group');
    var title = line.getAttribute('data-title') || 'Artikel';
    clearTimeout(state.timers[key]);

    if (group) {
      // Ware und Gravur-Serviceprodukt gehoeren zusammen: gemeinsam entfernen.
      var updates = {};
      document.querySelectorAll('[data-sz-line]').forEach(function (l) {
        if (l.getAttribute('data-group') === group) updates[l.getAttribute('data-key')] = 0;
      });
      enqueue(function () {
        return post('cart/update.js', { updates: updates }, '__title', title + ' wurde entfernt.');
      });
      return;
    }

    enqueue(function () {
      return post('cart/change.js', { id: key, quantity: 0 }, '__title', title + ' wurde entfernt.');
    });
  }

  /* ---------- Mobil: Sticky-Kassenbutton ---------- */

  function initSticky() {
    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }
    var bar = document.querySelector('[data-sz-sticky]');
    var cta = document.querySelector('[data-sz-summary-cta]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    state.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-hidden', entry.isIntersecting);
      });
    });
    state.observer.observe(cta);
  }

  /* ---------- Empfehlungen ---------- */

  function fetchRecs(productId, intent) {
    var cacheKey = productId + ':' + intent;
    if (!state.recsCache[cacheKey]) {
      var url =
        routeRoot() +
        'recommendations/products.json?limit=10&intent=' +
        intent +
        '&product_id=' +
        encodeURIComponent(productId);
      state.recsCache[cacheKey] = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.ok ? res.json() : { products: [] };
        })
        .then(function (data) {
          return (data && data.products) || [];
        })
        .catch(function () {
          return [];
        });
    }
    return state.recsCache[cacheKey];
  }

  function sizedImage(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function buildCard(product, grund) {
    var li = el('li', 'sz-cart-rec');

    var media = el('a', 'sz-cart-rec__media');
    media.href = product.url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    var imgSrc = product.featured_image || (product.images && product.images[0]);
    if (imgSrc) {
      var img = document.createElement('img');
      img.src = sizedImage(imgSrc, 400);
      img.alt = '';
      img.loading = 'lazy';
      img.width = 400;
      img.height = 400;
      media.appendChild(img);
    } else {
      media.appendChild(el('span', 'sz-cart-placeholder'));
    }
    li.appendChild(media);

    var body = el('div', 'sz-cart-rec__body');
    var welt = WELT[String(product.type || '').toLowerCase().trim()];
    if (welt) body.appendChild(el('span', 'sz-cart-overline', welt));
    var name = el('a', 'sz-cart-rec__name', product.title);
    name.href = product.url;
    body.appendChild(name);
    if (grund) body.appendChild(el('span', 'sz-cart-rec__grund', grund));
    li.appendChild(body);

    var foot = el('div', 'sz-cart-rec__foot');
    var priceText = money(product.price);
    if (product.price_varies) priceText = 'ab ' + money(product.price_min || product.price);
    foot.appendChild(el('span', 'sz-cart-rec__price', priceText));

    var variants = product.variants || [];
    var available = variants.filter(function (v) {
      return v.available;
    });
    if (variants.length === 1 && available.length === 1) {
      var btn = el('button', 'sz-btn sz-btn--secondary sz-btn--sm sz-cart-rec__btn', 'Hinzufügen');
      btn.type = 'button';
      btn.setAttribute('data-sz-rec-add', String(available[0].id));
      btn.setAttribute('data-title', product.title);
      btn.setAttribute('aria-label', product.title + ' hinzufügen');
      foot.appendChild(btn);
    } else {
      // Mehrere Varianten (Holz, Stoff, Größe): nicht raten, sondern zur Auswahl auf die Produktseite.
      var link = el('a', 'sz-btn sz-btn--secondary sz-btn--sm sz-cart-rec__btn', 'Ansehen');
      link.href = product.url;
      link.setAttribute('aria-label', product.title + ' ansehen');
      foot.appendChild(link);
    }
    li.appendChild(foot);
    return li;
  }

  function initRecs() {
    var box = document.querySelector('[data-sz-recs]');
    if (!box || !('fetch' in window)) return;
    var productId = box.getAttribute('data-product-id');
    if (!productId) return;
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 3;
    var grund = box.getAttribute('data-grund') || '';
    var exclude = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);

    var usable = function (list) {
      var seen = {};
      return list.filter(function (p) {
        if (!p || !p.available || seen[p.id]) return false;
        if (exclude.indexOf(String(p.id)) !== -1) return false;
        seen[p.id] = true;
        return true;
      });
    };

    fetchRecs(productId, 'complementary')
      .then(function (list) {
        var filtered = usable(list);
        if (filtered.length) return filtered;
        return fetchRecs(productId, 'related').then(usable);
      })
      .then(function (list) {
        if (!document.body.contains(box) || !list.length) return;
        var target = box.querySelector('[data-sz-recs-list]');
        if (!target) return;
        target.innerHTML = '';
        list.slice(0, limit).forEach(function (p) {
          target.appendChild(buildCard(p, grund));
        });
        box.hidden = false;
      });
  }

  function onRecAdd(btn) {
    var variantId = parseInt(btn.getAttribute('data-sz-rec-add'), 10);
    if (!variantId || btn.disabled) return;
    var title = btn.getAttribute('data-title') || 'Artikel';
    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt';
    enqueue(function () {
      return post(
        'cart/add.js',
        { items: [{ id: variantId, quantity: 1 }] },
        '__title',
        title + ' wurde hinzugefügt.'
      );
    });
  }

  /* ---------- Ereignisse ---------- */

  document.addEventListener('click', function (event) {
    if (!getRoot()) return;
    var step = event.target.closest('[data-sz-qty-step]');
    if (step && getRoot().contains(step)) {
      event.preventDefault();
      if (!step.disabled) onStep(step);
      return;
    }
    var remove = event.target.closest('[data-sz-remove]');
    if (remove && getRoot().contains(remove)) {
      event.preventDefault();
      onRemove(remove);
      return;
    }
    var add = event.target.closest('[data-sz-rec-add]');
    if (add && getRoot().contains(add)) {
      event.preventDefault();
      onRecAdd(add);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-sz-qty-input]');
    if (input) {
      var line = input.closest('[data-sz-line]');
      if (line) schedule(line, input, input.getAttribute('data-sz-focus'));
      return;
    }
    var note = event.target.closest && event.target.closest('[data-sz-cart-note]');
    if (note) {
      fetch(routeRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value }),
      }).catch(function () {
        /* Notiz wird spaetestens beim Absenden des Formulars mitgeschickt */
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-sz-qty-input]');
    if (!input) return;
    // Enter im Mengenfeld darf nicht den Kassen-Button (erster Submit) ausloesen.
    event.preventDefault();
    var line = input.closest('[data-sz-line]');
    if (line) schedule(line, input, input.getAttribute('data-sz-focus'), 0);
  });

  document.addEventListener('shopify:section:load', function () {
    afterRender(null);
  });

  function init() {
    if (getRoot()) afterRender(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


/* Werkstatt-Service: Zustimmung nach Paragraf 356 Abs. 4 BGB ist Pflicht, solange ein Service im Warenkorb liegt.
   Delegiert am Dokument, weil die Sektion nach Mengenaenderungen neu gerendert wird. */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form || form.id !== 'SzCartForm') return;
  var submitter = e.submitter;
  if (!submitter || submitter.name !== 'checkout') return;
  var check = form.querySelector('[data-sz-service-check]');
  if (!check || check.checked) return;
  e.preventDefault();
  var fehler = form.querySelector('[data-sz-service-fehler]');
  if (fehler) fehler.hidden = false;
  check.focus();
  check.closest('[data-sz-service]').scrollIntoView({ block: 'center', behavior: 'smooth' });
}, true);
document.addEventListener('change', function (e) {
  if (!e.target.matches || !e.target.matches('[data-sz-service-check]')) return;
  var fehler = document.querySelector('[data-sz-service-fehler]');
  if (fehler && e.target.checked) fehler.hidden = true;
});
